import { SET_MODAL } from '../actions/types';

const initialModalState = {
	show: false,
	incentiveKey: ' '
};

export default function modal(state = initialModalState, action) {
	if (!action.error && action.payload) {
		switch (action.type) {
			case SET_MODAL:
				return {
					...state,
					show: action.payload.show,
					incentiveKey: action.payload.incentiveKey
				};

			default:
				return state;
		}
	}

	return state;
}



// WEBPACK FOOTER //
// ./src/reducers/modal.js